import { renderToString } from 'react-dom/server'
import { StaticRouter } from 'react-router'
import { Routes, Route } from 'react-router-dom'
import Landing from './pages/Landing'
import Login from './pages/Login'
import Register from './pages/Register'

type PrerenderData = {
  url: string
}

export async function prerender(data: PrerenderData) {
  const url = data?.url ?? '/'

  const html = renderToString(
    <StaticRouter location={url}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Routes>
    </StaticRouter>
  )

  return {
    html,
    data: { url },
  }
}
